<template>
    <div v-if="status">
        <!-- contact edit -->
        <d-contact-edit
            v-model     = "edit"
            :contact-id = "contactId"
            :company-id = "companyId"
            @saved      = "onContactSaved"
        />
        <!-- contact edit -->

        <div class="pt-0 pb-1"  style="border-radius: 4px">
            <v-row class="no-frame">
                <div class="w-100 pl-2 pt-0 pb-1 white">
                    <v-col class="no-frame v-flex">
                        <c-toolbar-button
                            :size   = "22"
                            icon    = "mdi-account-plus"
                            :color  = "noContact ? 'error' : 'primary'"
                            tooltip = "Neuen Kontakt anlegen"
                            @click  = "onYes"
                        />
                        <c-toolbar-button
                            :size   = "22"
                            icon    = "mdi-reload"
                            color   = "primary"
                            tooltip = "Erneut vorbelegen"
                            @click  = "onReload"
                        />
                        <c-toolbar-button
                            :size   = "22"
                            icon    = "mdi-email"
                            color   = "primary"
                            tooltip = "Email senden"
                            @click  = "onMail"
                        />
                    </v-col>

                </div>

            </v-row>
            <v-divider />

            <v-autocomplete
                v-if           = "contacts && contacts.length > 0"
                :items         = "contacts"
                item-value     = "id"
                item-text      = "name"
                :label         = "label"
                v-model        = "selected"
                :return-object = true
                :multiple      = "true"
                :clearable     = "false"
                :rules         = "rules"
                @change        = "onSelected"
                :class="background ? background : 'contact-select'"
                hide-details
                chips
            >
                <template v-slot:selection="data">
                    <v-chip
                        v-if="data.index < count"
                        @click.stop  = "onEdit(data.item)"
                        @click:close = "onRemove(data.item)"
                        color        = "primary"
                        style        = "margin: 1px"
                        close
                        close-icon="mdi-close"
                    >
                        <div class="pl-1">
                            <div class="selected-items">
                                {{ data.item.name }}
                            </div>
                            <div class="selected-item-email">
                                {{ data.item.email }}
                            </div>
                        </div>
                    </v-chip>
                    <span
                        v-if="data.index === count && selected.length > count"
                        class="items-others"
                    >(+ {{ selected.length - count }})</span>
                </template>

                <template v-slot:item="data">
                    <v-row class="no-frame pt-1 pb-1" >
                        <v-col class="no-frame">
                            <div style="font-size: 16px" class="v-flex">
                                <div class="pr-2" style="margin-top: -2px; margin-left: -10px;">
                                    <v-icon size="18">{{ isPrefered (data.item) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                                </div>
                                <div style="margin-left: -2px;">
                                    {{ data.item.name }}
                                </div>
                            </div>
                            <div style="font-size: 12px; padding-left: 15px; margin-top: -3px;" v-for="(role, index) in data.item.roles" :key="index">
                                {{ role.name }}
                            </div>
                            <div style="font-size: 12px; padding-left: 15px;">
                                {{ data.item.email }}
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </v-autocomplete>

            <div v-if="noContact">
                <v-alert
                    dense
                    outlined
                    class="mt-1 mb-2"
                    color="error"
                    style="font-size: 15px"
                >
                    {{ $t('contact.query.notExists') }}
                </v-alert>
            </div>
        </div>
    </div>
</template>

<script>

import Mail           from "@/modules/inc/mail/service/Mail";
import Contact        from "@/modules/msd/company/contact/service/Contact";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";
import DContactEdit    from "@/modules/msd/company/contact/components/controlls/DContactEdit";

export default {
    name: "CContactSelect",
    components: {
        DContactEdit,
        CToolbarButton,
    },
    props: {
        value: {

        },

        companyId: {

        },

        incident: {

        },

        index: {

        },

        status: {

        },

        label: {

        },

        rules: {
            required: false
        },
        background: {
            required: false,
            type    : String,
            default : function () {
                return "contact-select"
            }
        }
    },

    data: () => ({
        edit    : false,
        contactId : null,
        selected: [],
        count   : 2,
        recipients : [],
        contacts   : [],
        loaded: false,
        highestRating: 0,
    }),

    mounted() {
        this.loadContacts();
    },

    watch: {
        companyId () {
            console.log("company changed")
            this.loadContacts();
        },
        selected: {
            deep: true,
            handler: function () {
            }
        }
    },

    computed: {
        noContact () {
            return this.loaded && (!this.contacts || this.contacts.length === 0);
        }
    },

    methods: {
        onEdit (contact) {
            this.contactId = contact.id;
            this.edit = true;
        },

        onSelected () {
            this.emitInput();
        },

        onRemove (item) {
            const index = this.selected.findIndex(s => s.id === item.id);
            if (index >= 0) {
                this.selected.splice(index, 1)
                this.emitInput();
            }
        },

        onContactSaved () {
            this.loadContacts();
        },

        onYes () {
            this.contactId = -1;
            this.edit = true;
        },

        onReload () {
            this.selected = [];
            this.emitInput();
            this.$nextTick(() => {
                this.loadContacts();
            })
        },

        onMail () {
            const stepData = this.incident.data[this.index];
            Mail.mail(this.companyId, this.incident, this.index, stepData.stepId, this.status, this.selected).then(mail => {
                this.$emit ("sendmail", mail);
            });
        },

        emitInput () {
            const contactIds = this.selected.map (c => c.id);
            this.$emit("input", contactIds);
        },

        isPrefered (contact) {
            const c = this.recipients.find (x => x.contact.id === contact.id);
            if (!c) {
                return false;
            }

            return c.rating === this.highestRating;
        },

        loadContacts () {
            if (!this.status) {
                return;
            }

            this.selected = [];
            this.loaded = false;
            if (!this.companyId) {
                this.contacts = [];
                return;
            }

            const roles = [ 3 ];
            Contact.recipients(this.incident, this.status.id, this.companyId, roles).then(data => {
                this.recipients = data;
                this.contacts = this.recipients.map(r => r.contact)
                this.loaded = true;

                if (data.length === 0) {
                    return;
                }

                if (!this.value) {
                    return;
                }

                if (this.value.length > 0) {
                    this.value.forEach (contactId => {
                        this.selected.push(this.contacts.find(c => c.id === contactId))
                    });

                    return;
                }

                this.highestRating = 0;
                for (let i = 0; i < this.recipients.length; i++) {
                    const rating = this.recipients[i].rating;
                    if (rating > this.highestRating) {
                        this.highestRating = rating;
                    }
                }

                const recipientsWithhighestRating = this.recipients.filter (r => r.rating === this.highestRating);
                if (recipientsWithhighestRating.length > 0 && recipientsWithhighestRating.length <= 3) {
                    recipientsWithhighestRating.forEach (recipient => {
                        this.selected.push(recipient.contact)
                    });
                }

                this.emitInput();
           });
        }
    }
}
</script>

<style scoped>

.no-contact {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 16px;
}

.no-contact-action {
    text-align: center;
}

.selected-items,
.selected-item-email{
    width: 110px;
    max-width: 120px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.selected-items {
    margin-top: 0px;
    font-size: 14px;
}

.selected-item-email {
    font-size: 10px;
    margin-top: -6px;
}

.items-others {
    font-size: 13px;
    padding-left: 5px;
    margin-top: -2px;
}

::v-deep .v-select__selections {
    margin-top: 0;
    margin-bottom: 4px;
}

::v-deep .theme--light.v-chip:not(.v-chip--active) {
/*    background: #eceff1; */
}

::v-deep .v-select.v-select--chips .v-chip--select.v-chip--active::before {
    opacity: 0.12;
}

::v-deep .v-chip.v-size--default {
    height: 30px;
}

.contact-select {
    background-color: #f5f5f5;
}

</style>